import { render, staticRenderFns } from "./previous.vue?vue&type=template&id=18b6a454&scoped=true&"
import script from "./previous.vue?vue&type=script&lang=js&"
export * from "./previous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b6a454",
  null
  
)

export default component.exports